export function SirvSpinner() {
  return (
    <img
      style={{
        maxWidth: "150px",
      }}
      src="https://sirv.sirv.com/GIFs/sirv-loader.gif?w=150"
      alt="loading progress"
    />
  );
}
